<div class="position-relative">
  @if (alter()) {
    <i class="position-absolute top-50 start-50 translate-middle fa-solid fa-camera fa-2x color-white opacity-50"></i>
<!--    <i class="position-absolute top-0 end-50  fa-solid fa-camera fa-2x"></i>-->
  }
  @let thumbnail = animal()?.profilePictureThumbnailUrl;

  @if (thumbnail) {
    <img [ngClass]="{'clickable': clickable()}" class="profile-picture" src="{{ thumbnail }}" loading="lazy"/>
  } @else {
    <app-animal-svg [animalType]="animal()?.type" class="img-fluid img-max m-0"/>
  }
</div>
